import { Box, Text, Flex } from "@chakra-ui/react";
import Anexos from "components/Anexos";
import ButtonAnexarArquivos from "ui/components/Button/ButtonAnexarArquivos";
import OutlineButton from "ui/components/Button/OutlineButton";
import history from "infra/helpers/history";
import { useState, useCallback } from "react";
import { AnexoResponse } from "core/features/arquivo/typings";
import useGetArquivosCliente from "core/features/cliente/hooks/useGetArquivosCliente";
import useDeleteArquivosCliente from "core/features/cliente/hooks/useDeleteArquivosCliente";
import useUploadArquivoCliente from "core/features/cliente/hooks/useUploadArquivoCliente";
import { useLoading } from "ui/components/GlobalLoading";
import { useEffect } from "react";
import { showSuccess } from "infra/helpers/alerta";

export default function DocumentosCliente({
  clienteId,
}: {
  clienteId: string;
}) {
  const [anexos, setAnexos] = useState<(File | AnexoResponse)[] | undefined>(
    []
  );
  const [disableButtonAnexar, setDisabledButtonAnexar] = useState(false);

  const { data, isLoading, refetch } = useGetArquivosCliente(clienteId);

  const { mutate: handleDelete, isLoading: isLoadingDelete } =
    useDeleteArquivosCliente(clienteId);

  useLoading(isLoading || isLoadingDelete);

  useEffect(() => {
    if (data) {
      setAnexos(data);
    }
  }, [data]);

  const onDeleteFile = useCallback(
    async (id: string) => {
      return new Promise(async (resolve, reject) => {
        handleDelete(id, {
          onSuccess: () => {
            resolve(null);
            showSuccess().then(() => {
              refetch();
            });
          },
          onError: reject,
        });
      });
    },
    [handleDelete, refetch]
  );

  return (
    <Box>
      <Flex flex={1} gap={10}>
        <Text fontSize={"18px"} fontWeight={"bold"} mb="32px">
          Documentos
        </Text>
        <ButtonAnexarArquivos
          disabled={disableButtonAnexar}
          buttonText="Anexar"
          maxFileSizeMb={20}
          currentFilesLength={anexos?.length || 0}
          onAnexar={(files) => {
            if (files) {
              setAnexos((state) => (state ? [...state, ...files] : files));
            }
          }}
        />
      </Flex>

      {!isLoading && anexos?.length ? (
        <Anexos
          anexos={anexos}
          setValue={setAnexos}
          autoUploadMutation={useUploadArquivoCliente}
          autoUploadMutationArgs={[clienteId]}
          onRemove={onDeleteFile}
          onStartUploadMutation={() => setDisabledButtonAnexar(true)}
          onFinishUploadMutation={() => setDisabledButtonAnexar(false)}
          containerHeight={"fit-content"}
        />
      ) : null}

      <Flex justifyContent={"flex-end"} mt="32px" gap={4}>
        <OutlineButton onClick={() => history.push("/cadastros/clientes")}>
          Voltar
        </OutlineButton>
      </Flex>
    </Box>
  );
}
